import React, { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";
import { formatApiErrorDetail } from "../context/AuthContext";
import Seo from "../components/Seo";
import { GoldButton } from "../components/Buttons";

const API = process.env.REACT_APP_BACKEND_URL;

export default function ResetPassword() {
    const [params] = useSearchParams();
    const token = params.get("token") || "";
    const [password, setPassword] = useState("");
    const [done, setDone] = useState(false);
    const [error, setError] = useState("");
    const [busy, setBusy] = useState(false);

    const inputCls =
        "w-full h-12 bg-white/5 border border-white/15 rounded-lg px-4 text-white placeholder-white/35 focus:outline-none focus:border-[#C8A45D] transition-colors duration-200";

    const submit = async (e) => {
        e.preventDefault();
        setError("");
        setBusy(true);
        try {
            await axios.post(`${API}/api/auth/reset-password`, { token, password }, { withCredentials: true });
            setDone(true);
        } catch (err) {
            setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
        } finally {
            setBusy(false);
        }
    };

    return (
        <section className="min-h-[80vh] bg-[#111318] flex items-center justify-center px-5 sm:px-8 py-32">
            <Seo title="Reset Password | Freedom Tax Filer" description="Choose a new password for your Freedom Tax Filer account." path="/reset-password" noindex />
            <div className="w-full max-w-md text-center">
                <p className="text-[#C8A45D] text-[12px] uppercase tracking-[0.2em]">Freedom Tax Filer</p>
                <h1 className="font-display text-white text-3xl sm:text-4xl mt-4">
                    Choose a new <em className="italic text-gold-gradient">password.</em>
                </h1>
                {done ? (
                    <div className="mt-8" data-testid="reset-success">
                        <p className="text-white/70">Your password has been updated. You can now sign in with your new password.</p>
                        <div className="mt-6">
                            <GoldButton asChild data-testid="reset-to-login">
                                <Link to="/login">Go to Sign In</Link>
                            </GoldButton>
                        </div>
                    </div>
                ) : (
                    <form onSubmit={submit} className="mt-8 space-y-4 text-left" data-testid="reset-form">
                        <div>
                            <label htmlFor="reset-password-input" className="block text-[11px] uppercase tracking-[0.14em] text-white/50 mb-2">New password</label>
                            <input id="reset-password-input" type="password" required minLength={8} autoComplete="new-password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="At least 8 characters" className={inputCls} data-testid="reset-password-input" />
                        </div>
                        {error && <p className="text-[#e07a5f] text-sm" data-testid="reset-error">{error}</p>}
                        <GoldButton type="submit" disabled={busy || !token} className="w-full h-12" data-testid="reset-submit">
                            {busy ? "Please wait…" : "Update Password"}
                        </GoldButton>
                        {!token && <p className="text-[#e07a5f] text-sm" data-testid="reset-token-missing">This reset link is missing its token. Please request a new link from the sign-in page.</p>}
                    </form>
                )}
            </div>
        </section>
    );
}
